import { IAttribute, IModel, LinkedService, Metamodel, workdayAuthTypes } from 'shell-models-lib';
import { adfModelTypeMap } from '../../registries/consts/adf-model-type-map-const';
import { format } from '../../shared/utils/string.util';

@Metamodel.model({
    name: adfModelTypeMap.workday.linkedServiceType,
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.Workday_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.Workday_DisplayText)
    ]
})
export class WorkdayLinkedService extends LinkedService {
    public static readonly MODEL: IModel;

    public static SUBDOMAIN: IAttribute;
    public static TENANT_ID: IAttribute;
    public static USER_NAME: IAttribute;
    public static PASSWORD: IAttribute;
    public static SERVICE_VERSION: IAttribute;
    public static SERVICE: IAttribute;
    public static OPERATION: IAttribute;

    @Metamodel.attribute({
        display: stringResources.ModelName_Subdomain,
        templatable: true,
        association: 'SUBDOMAIN'
    })
    public subDomain?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Tenant,
        templatable: true,
        association: 'TENANT_ID'
    })
    public tenantId: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_AuthenticationType
    })
    public authenticationType: workdayAuthTypes;

    @Metamodel.attribute({
        display: stringResources.ModelName_UserName,
        templatable: true,
        association: 'USER_NAME'
    })
    public userName: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Password,
        templatable: true,
        association: 'PASSWORD'
    })
    public password: string;

    @Metamodel.attribute({
        display: stringResources.Workday_Service_Version_DisplayText,
        templatable: true,
        association: 'SERVICE_VERSION'
    })
    public serviceVersion: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Service,
        templatable: true,
        association: 'SERVICE'
    })
    public service: string;

    @Metamodel.attribute({
        display: stringResources.ExtensibleActivity_OperationLabel,
        templatable: true,
        association: 'OPERATION'
    })
    public operation: string;
}
